import { gql } from '@apollo/client';
import { NextGenMembershipInput } from './addAdmin.queries';

export interface UpdateSuperAdminInput {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  password?: string;
  roles: string[];
  tenant?: string;
  memberships?: NextGenMembershipInput[];
}

export interface UpdateSuperAdminResponse {
  updateAdminUser?: any;
  updateUser?: any;
}

export const UPDATE_ADMIN_USER = gql`
  mutation updateAdminUser($input: UpdateAdminUserInput!) {
    updateAdminUser(input: $input) {
      email
    }
  }
`;

export const UPDATE_USER_MUTATION = gql`
  mutation updateUser($input: putUser!) {
    updateUser(input: $input) {
      uuid
    }
  }
`;
